import React from 'react'
import { Link } from 'react-router-dom'

export default function PolitiqueConfidentialite() {
  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <h1 style={h1Style}>Politique de confidentialité</h1>
        <p style={metaStyle}>Dernière mise à jour : 18 avril 2026</p>

        <section style={sectionStyle}>
          <h2 style={h2Style}>1. Responsable du traitement</h2>
          <p style={pStyle}>
            Le responsable du traitement des données personnelles est la société <strong>Nutryn</strong>, EURL,
            dont le siège social est situé au 480 route des marais de Culas, 74330 Sillingy, France.
            SIRET : 882 544 414 00015.
          </p>
          <p style={pStyle}><strong>Contact :</strong> contact@nutrygenius.com</p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>2. Données collectées</h2>
          <p style={pStyle}>Dans le cadre de l'utilisation de KudoGenius, nous collectons les données suivantes :</p>
          <p style={pStyle}>
            <strong>Pour le parent (compte utilisateur) :</strong> adresse e-mail, mot de passe (chiffré), date de création du compte.
          </p>
          <p style={pStyle}>
            <strong>Pour l'enfant suivi :</strong> pseudonyme (pas de nom réel obligatoire), âge,
            défis comportementaux personnalisés, saisies quotidiennes (scores), points de récompense,
            notes échangées entre parents et école, exercices de respiration réalisés.
          </p>
          <p style={pStyle}>
            <strong>Pour les professionnels (annuaire) :</strong> nom, prénom, profession, ville, pays,
            adresse e-mail professionnelle, site web, numéro de téléphone (optionnel).
          </p>
          <p style={pStyle}>
            Aucune donnée d'identité réelle de l'enfant n'est requise. Le système fonctionne avec des pseudonymes.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>3. Finalités du traitement</h2>
          <p style={pStyle}>Les données sont traitées pour les finalités suivantes :</p>
          <p style={pStyle}>
            — Permettre le suivi éducatif et comportemental de l'enfant par ses parents, l'école et les professionnels de santé autorisés.
            — Générer des statistiques de progression (tendances, scores hebdomadaires).
            — Permettre la communication parents-école via les notes.
            — Proposer un annuaire de professionnels aux familles.
            — Assurer le fonctionnement technique de l'application (authentification, sécurité).
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>4. Base légale du traitement</h2>
          <p style={pStyle}>
            Le traitement des données est fondé sur le <strong>consentement</strong> de l'utilisateur
            (article 6.1.a du RGPD), recueilli lors de la création du compte et lors de l'ajout d'un enfant.
          </p>
          <p style={pStyle}>
            Conformément à l'article 45 de la loi Informatique et Libertés et aux recommandations de la CNIL,
            le consentement parental est requis pour tout traitement de données relatives à un enfant de moins de 15 ans.
            Le parent qui crée le compte et ajoute un enfant certifie être titulaire de l'autorité parentale.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>5. Destinataires des données</h2>
          <p style={pStyle}>Les données de l'enfant sont accessibles uniquement aux personnes suivantes :</p>
          <p style={pStyle}>
            — Le parent titulaire du compte (accès complet).
            — Le personnel scolaire disposant du code d'accès école fourni par le parent (défis scolaires uniquement).
            — Le professionnel de santé disposant du code d'accès thérapeute fourni par le parent (lecture seule).
          </p>
          <p style={pStyle}>
            Aucune donnée n'est vendue, louée ou transmise à des tiers à des fins commerciales ou publicitaires.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>6. Hébergement et sécurité</h2>
          <p style={pStyle}>
            Les données sont hébergées par <strong>Supabase</strong> sur des serveurs situés dans l'Union européenne
            (région AWS eu-west). L'accès aux données est protégé par des politiques de sécurité au niveau
            de la base de données (Row Level Security), des fonctions serveur sécurisées (SECURITY DEFINER),
            et un chiffrement des mots de passe.
          </p>
          <p style={pStyle}>
            Le site web est hébergé par <strong>Vercel</strong> (États-Unis). Les transferts de données
            sont encadrés par les clauses contractuelles types de la Commission européenne.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>7. Durée de conservation</h2>
          <p style={pStyle}>
            Les données sont conservées tant que le compte utilisateur est actif. En cas de suppression du compte,
            toutes les données associées (profil, enfants, défis, saisies, notes, récompenses) sont supprimées
            dans un délai de 30 jours.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>8. Vos droits</h2>
          <p style={pStyle}>
            Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits suivants :
          </p>
          <p style={pStyle}>
            — <strong>Droit d'accès :</strong> obtenir une copie de vos données personnelles.
            — <strong>Droit de rectification :</strong> corriger des données inexactes ou incomplètes.
            — <strong>Droit à l'effacement :</strong> demander la suppression de vos données.
            — <strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré et lisible.
            — <strong>Droit d'opposition :</strong> vous opposer au traitement de vos données.
            — <strong>Droit de retrait du consentement :</strong> retirer votre consentement à tout moment.
          </p>
          <p style={pStyle}>
            Pour exercer ces droits, contactez-nous à : <strong>contact@nutrygenius.com</strong>
          </p>
          <p style={pStyle}>
            En cas de litige, vous pouvez introduire une réclamation auprès de la Commission Nationale
            de l'Informatique et des Libertés (CNIL) : <a href="https://www.cnil.fr" target="_blank" rel="noreferrer" style={linkStyle}>www.cnil.fr</a>
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>9. Cookies</h2>
          <p style={pStyle}>
            KudoGenius n'utilise actuellement aucun cookie publicitaire, analytique ou de suivi.
            Seuls des cookies techniques strictement nécessaires au fonctionnement de l'application sont utilisés
            (gestion de la session d'authentification). Cette politique sera mise à jour en cas d'évolution.
          </p>
        </section>

        <section style={sectionStyle}>
          <h2 style={h2Style}>10. Modifications</h2>
          <p style={pStyle}>
            La présente politique de confidentialité peut être mise à jour à tout moment.
            La date de dernière mise à jour figure en haut de cette page.
            En cas de modification substantielle, les utilisateurs seront informés par e-mail
            ou par notification dans l'application.
          </p>
        </section>

        <div style={{ textAlign: 'center', marginTop: 32 }}>
          <Link to="/mentions-legales" style={linkStyle}>Mentions légales</Link>
          <span style={{ margin: '0 12px', color: '#cbd5e1' }}>|</span>
          <Link to="/" style={linkStyle}>← Retour à l'accueil</Link>
        </div>
      </div>
    </div>
  )
}

const containerStyle = {
  minHeight: '100vh', background: '#f8fafc', padding: '40px 20px',
  fontFamily: "'Inter', sans-serif", display: 'flex', justifyContent: 'center'
}
const cardStyle = {
  background: '#fff', borderRadius: 16, padding: '40px 36px',
  maxWidth: 720, width: '100%', boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
  border: '1px solid #e2e8f0'
}
const h1Style = {
  fontFamily: "'Playfair Display', serif", fontSize: 28, fontWeight: 900,
  color: '#1e293b', marginBottom: 4
}
const metaStyle = { fontSize: 12, color: '#94a3b8', marginBottom: 32 }
const sectionStyle = { marginBottom: 28 }
const h2Style = { fontSize: 16, fontWeight: 700, color: '#1e293b', marginBottom: 8 }
const pStyle = { fontSize: 14, color: '#475569', lineHeight: 1.7, marginBottom: 8 }
const linkStyle = { color: '#2563eb', fontWeight: 600, textDecoration: 'underline' }
